module.exports = __webpack_public_path__ + "static/img/shouzhi_hp.d6a1395b.gif";